import { render, staticRenderFns } from "./changeWallet.vue?vue&type=template&id=9b53af10&scoped=true&"
import script from "./changeWallet.vue?vue&type=script&lang=js&"
export * from "./changeWallet.vue?vue&type=script&lang=js&"
import style0 from "./changeWallet.vue?vue&type=style&index=0&id=9b53af10&prod&scoped=true&lang=css&"
import style1 from "./changeWallet.vue?vue&type=style&index=1&id=9b53af10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b53af10",
  null
  
)

export default component.exports